







































/** @format */

import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
// 组件
import AddEditChannel from './add-edit-channel.vue';
// 方法工具
import Utils from '@/utils/common';
import * as _ from 'lodash';
// axios请求
import { deleteChannelList } from '@/api/parking-lot-management/index';
// 导入字典
import { dictChannelTypeMap } from '@/types/parking-lot-management/dictionaries';

@Component({
  components: { AddEditChannel }
})
export default class AddEditChannelList extends Mixins(TableMixin, TableWidthMixin) {
  // 车场id是否外部传入且不可编辑标志, 车场三连创建时使用
  @Prop({ type: Boolean, default: false })
  isParkdisabled!: boolean;
  // 外部传入车场id
  @Prop({ type: String, default: '' })
  parkId!: string;

  tableData: any[] = []; // 表数据
  dataForm = null; //通道表单数据，编辑回填
  channelId = '';
  // 表单的显示和隐藏
  isShowForm: boolean = true;
  isEdit: boolean = false;

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 50,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '通道名称',
        dataIndex: 'channelName',
        width: 200
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 160
      },
      {
        title: '所属区域',
        dataIndex: 'areaName',
        width: 120
      },
      {
        title: '通道类型',
        dataIndex: 'channelType',
        width: 120,
        customRender: (text: any) => dictChannelTypeMap[text]
      },
      {
        title: '源区域',
        dataIndex: 'fromAreaName'
        // width: 110,
      },
      {
        title: '目标区域',
        dataIndex: 'toAreaName'
        // width: 110,
      },
      {
        title: '操作',
        dataIndex: 'operator',
        width: 160,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  /* method */

  /**
   * 删除项
   */
  async toDelete(row: any) {
    const { channelId, parkId } = row;
    try {
      const { status, data } = await deleteChannelList({
        channelId,
        parkId
      });
      this.$message.success('删除成功');
      const index = this.tableData.findIndex(item => item.channelId === channelId);
      if (index > -1) {
        this.tableData.splice(index, 1);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '删除失败');
    }
  }

  /**
   * 隐藏表单
   */
  hideForm() {
    this.isShowForm = false;
  }

  /**
   * 表单保存成功
   */
  onFormOk(values: any) {
    this.isShowForm = false;
    if (this.isEdit) {
      // 编辑成功更新
      const index = this.tableData.findIndex(item => item.channelId === values.channelId);
      if (index > -1) {
        this.tableData.splice(index, 1, values);
      }
    } else {
      // 新增成功更新
      this.tableData.push(values);
    }
  }

  // 展示新增表单
  showAddForm() {
    this.isShowForm = true;
    this.isEdit = false;
    this.dataForm = null;
  }

  // 展示编辑表单
  showEditForm(data: any) {
    console.log(data);
    this.isShowForm = true;
    this.isEdit = true;
    this.dataForm = data;
  }
}
